const OTP_SEND_GUARD_KEY = '__gweffitOtpSendGuard';
const OTP_SEND_COOLDOWN_MS = 10000;

function getGlobalGuard() {
  const root = typeof window !== 'undefined' ? window : {};
  if (!root[OTP_SEND_GUARD_KEY]) {
    root[OTP_SEND_GUARD_KEY] = {
      inFlight: false,
      lastStartedAt: 0,
      lastContext: null,
    };
  }
  return root[OTP_SEND_GUARD_KEY];
}

export function beginOtpSendAttempt(context = 'unknown') {
  const guard = getGlobalGuard();
  const now = Date.now();

  if (guard.inFlight) {
    return { ok: false, reason: 'inflight', lastContext: guard.lastContext, ageMs: now - (guard.lastStartedAt || now) };
  }

  if (guard.lastStartedAt && (now - guard.lastStartedAt) < OTP_SEND_COOLDOWN_MS) {
    return { ok: false, reason: 'cooldown', lastContext: guard.lastContext, ageMs: now - guard.lastStartedAt };
  }

  guard.inFlight = true;
  guard.lastStartedAt = now;
  guard.lastContext = context;
  return { ok: true };
}

export function finishOtpSendAttempt() {
  const guard = getGlobalGuard();
  guard.inFlight = false;
}

export function getOtpSendGuardState() {
  const guard = getGlobalGuard();
  return {
    inFlight: Boolean(guard.inFlight),
    lastStartedAt: guard.lastStartedAt || 0,
    lastContext: guard.lastContext || null,
  };
}
